import { PropsWithChildren } from 'react';

import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

export type NumCols = 2 | 3 | 4;
type TokenVariable = ReturnType<typeof token>;

export interface RowGridProps {
	numCols: NumCols;
	colWidth?: string | TokenVariable;

	numRows?: number;
	rowHeight?: string | TokenVariable;

	columnGap?: string | TokenVariable;
	rowGap?: string | TokenVariable;

	paddingInline?: string | TokenVariable;
	paddingBlock?: string | TokenVariable;

	marginInline?: string | TokenVariable;
	marginBlock?: string | TokenVariable;
}
// eslint-disable-next-line complexity
export const RowGrid = ({
	children,
	numCols,
	colWidth,
	numRows,
	rowHeight,
	rowGap,
	columnGap,
	paddingInline,
	paddingBlock,
	marginInline,
	marginBlock,
}: PropsWithChildren<RowGridProps>) => {
	return (
		<div
			style={{
				gridTemplateColumns: `${(colWidth ? `${colWidth} ` : '1fr ').repeat(numCols)}`,
				gridTemplateRows: `${numRows && (rowHeight ? `${rowHeight} ` : '1fr ').repeat(numRows)}`,
				rowGap: rowGap,
				columnGap: columnGap,
				paddingInline: paddingInline,
				paddingBlock: paddingBlock,
				marginInline: marginInline,
				marginBlock: marginBlock,
			}}
			css={css({
				display: 'grid',
			})}
		>
			{children}
		</div>
	);
};
